// Small versions of images for places that show them tiny (shop circles).
//  - Supabase storage objects go through the storage image transformer
//    (/storage/v1/render/image, imgproxy on the VPS), cropped to a square.
//  - Images under /v2/ have a 240px .webp copy under /v2/t/ (made once with
//    PIL from public/v2; add a copy there when adding a new circle image).
// Anything else, or a copy that fails to load, falls back to the original.

const OBJECT = '/storage/v1/object/public/';
const RENDER = '/storage/v1/render/image/public/';

export function thumbOf(src: string, size = 240): string {
  if (!src) return src;
  if (src.includes(OBJECT) && !/\.(svg|gif)(\?|$)/i.test(src)) {
    const [base] = src.split('?');
    return `${base.replace(OBJECT, RENDER)}?width=${size}&height=${size}&resize=cover&quality=78`;
  }
  const m = src.match(/^(?:https?:\/\/[^/]+)?\/v2\/(?!t\/)(.+)\.(jpe?g|png|webp)$/i);
  if (m) return `/v2/t/${m[1]}.webp`;
  return src;
}
